import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-handle-error',
    templateUrl: './handle-error.component.html',
    styleUrls: ['./handle-error.component.css'],
    standalone: false
})
export class HandleErrorComponent implements OnInit {

  @Input() control: any;
  @Input() name: string = '';
  @Input() clicked: boolean = false;
  @Input() showSampleValues: boolean = false;
  @Input() sampleValue: any = null;
  @Input() fieldType: string = 'text';
  @Input() minLengthValue: number = 2;

  constructor() { }

  ngOnInit(): void {
  }
  getSampleValue(): string {
    if (!this.control || !this.control.parent) {
      return 'N/A';
    }

    if(this.sampleValue) {
      return this.sampleValue;
    }

    const formGroup = this.control.parent as FormGroup;
    const sampleValues = formGroup.get('sampleValues') as FormGroup;

    if (!sampleValues) {
      return 'N/A';
    }

    let controlName = Object.keys(formGroup.controls).find(key => formGroup.controls[key] === this.control);

    if (!controlName) {
      return 'N/A';
    }
    return sampleValues.get(controlName)?.value || 'N/A';
  }

  hasSecurityViolation(): boolean {
    if (this.fieldType === 'password') return false;
    if (!this.control?.value || (!this.clicked && !this.control?.touched)) return false;
    const input = this.control.value.toString();    
    const dangerousPatterns = [
      /<[^>]*>/,                    // HTML tags like <script>, <h1>, etc.
      /javascript:/gi,              // JavaScript protocol
      /on\w+\s*=/gi,               // Event handlers like onclick=
      /^[\=\+\-@]/,                // CSV formula injection
      /cmd\s*\|/gi,                // Command injection
      /powershell/gi,              // PowerShell
      /\<script\>/gi,              // Script tags
      /\<\/script\>/gi,            // Closing script tags
      /expression\s*\(/gi          // CSS expressions
    ];
    
    return dangerousPatterns.some(pattern => pattern.test(input));
  }
}
